import { instantiateBodies } from './configEntities/createBodies.js';
import { SceneManager } from './configScene/scene.js'

export const sceneManager = new SceneManager();

const bodies = instantiateBodies();
const firstBody = bodies.sagittariusa;
sceneManager.setBodies(bodies, firstBody);
sceneManager.startAnimationLoop();